import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CButton from '@/components/shared/CButton/CButton.vue';
import CError from '@/components/shared/CError.vue';
import CInput from '@/components/shared/CInput/CInput.vue';
import { completeExternalSignUp } from '@/api/auth';
import { externalAuthErrorMessage } from '@/utils/authUtils';
import type { ExternalAuthResult } from '@/typings/auth/externalAuth';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailStep',
  props: {
    pendingTicket: null
  },
  emits: ["back", "completed"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'back'): void;
    (event: 'completed', result: ExternalAuthResult): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { pendingTicket: string };




const email = ref('');
const submitting = ref(false);
const errorMessage = ref('');

const submit = async () => {
    errorMessage.value = '';

    submitting.value = true;
    try {
        const result = await completeExternalSignUp({
            pendingTicket: props.pendingTicket,
            email: email.value.trim()
        });
        // Stays disabled: the page is leaving for Stripe and the ticket is spent
        emit('completed', result);
    } catch (error) {
        errorMessage.value = externalAuthErrorMessage(error, 'We could not create your account. Please try again.');
        submitting.value = false;
    }
};

return { __sfc: true,props, emit, email, submitting, errorMessage, submit, ValidationObserver, ValidationProvider, CButton, CError, CInput }
}

})